import { Pipe, PipeTransform } from '@angular/core';
import { Config } from '@shared/configs/config';
import { parseApiDate } from '@shared/helpers/date-format.helper';

@Pipe({name: 'dateFormat', pure: true})

export class DateFormatPipe implements PipeTransform {
  transform(value: string, format?: string): string {
    const parsedDate = parseApiDate(value);
    return parsedDate ? parsedDate.format(format ? format : Config.DATE_FORMAT_DOTS) : '';
  }
}
